var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ebx-event-button",on:{"click":_vm.onClick}},[_vm._t("icon"),_c('span',{staticClass:"ebx-event-button__label",domProps:{"innerHTML":_vm._s(_vm.label)}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }